module.exports = __webpack_public_path__ + "static/media/8OLA13.16eac0b9.jpg";